import { render, staticRenderFns } from "./Nordea.vue?vue&type=template&id=7c106a07"
import script from "./Nordea.vue?vue&type=script&lang=js"
export * from "./Nordea.vue?vue&type=script&lang=js"
import style0 from "./Nordea.vue?vue&type=style&index=0&id=7c106a07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports